module.exports = __webpack_public_path__ + "img/apidays-2022-snapshot-2.9875dd9c.jpg";